import React from 'react';
import { useSelector } from 'react-redux';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';

import { Select } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

import _ from 'underscore';

const typeOptions = [
  { value: 'D', label: 'Debet' },
  { value: 'K', label: 'Kredit' },
];

const initialState = {
  items: [
    {
      typeSelected: null,
      coa_id: null,
      coa: null,
    },
  ],
};

export const FormCoaes = ({ data, onChange, loading }) => {
  const StateForm = useSelector((state) => state?.Form);
  const [{ items }, setState] = React.useState(initialState);

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  const $handleItemsChange = async (i, e, n) => {
    let newItems = [...items];
    newItems[i][n] = e;

    if (n === 'coa') {
      newItems[i][`${n}_id`] = e?.id;
    }

    setState((prevState) => ({
      ...prevState,
      items: newItems,
    }));
  };

  const $addMoreFields = async (i) => {
    setState((prevState) => ({
      ...prevState,
      items: [
        ...items,
        {
          typeSelected: null,
          coa_id: null,
          coa: null,
        },
      ],
    }));
  };

  const $removeField = async (i) => {
    let newItems = [...items];
    newItems.splice(i, 1);
    setState((prevState) => ({
      ...prevState,
      items: newItems,
    }));
  };

  React.useEffect(() => {
    let newItems = [];

    if (items) {
      items?.forEach((p) => {
        p.type = p?.typeSelected?.value
        newItems.push(p)
      });
    }

    onChange(newItems);
  }, [items]);

  React.useEffect(() => {
    if (!data) return;

    let p = [];
    if (data) {
      data?.forEach((i) => {
        let ot = null
        _.each(typeOptions, (t) => {
          if (t?.value === i?.type) {
            ot = t
          }
        })

        p.push({
          id: i?.id,
          typeSelected: ot,
          coa_id: i?.coa?.id,
          coa: i?.coa,
        });
      });
    }
    setState((prevState) => ({ ...prevState, items: p }));
  }, [data]);

  React.useEffect(() => {
    if (!data) {
      setState({
        items: [
          {
            typeSelected: null,
            coa_id: null,
            coa: null,
          },
        ],
      });
    }
  }, []);

  return (
    <div className="mt-3">
      <div className="fw-semibold py-2 fs-6">Data Coa</div>
      {loading ? (
        <div className="row ">
          {dummy?.map((d, i) => (
            <div className="col-md-3" key={i}>
              <SkeletonsForm count={1} />
            </div>
          ))}
        </div>
      ) : (
        <div className="py-2">
          <table
            width="100%"
            className={cn(
              'table table-vcenter card-table datatable border',
              StateForm?.errors?.orders ? 'border-danger' : ''
            )}
          >
            <thead className="bg-light">
              <tr className="th">
                <td style={{ whiteSpace: 'initial', width: '200px' }}>
                  Tipe
                </td>
                <td style={{ whiteSpace: 'initial', width: '200px' }}>
                  Coa
                </td>
                <td style={{ whiteSpace: 'initial', width: '80px'}}>
                  &nbsp;
                </td>
              </tr>
            </thead>
            <tbody>
              {items?.map((e, i) => (
                <tr
                  key={i}
                  className={cn(
                    StateForm?.errors[`items.${i}.debit_id`]
                    ? 'text-danger border-danger'
                    : null
                  )}
                >
                  <td style={{ whiteSpace: 'initial', width: '200px' }}>
                    <div className="mb-3">
                      <Select
                        isClearable
                        classNamePrefix={
                          StateForm?.errors?.items || StateForm?.errors[`items.${i}.type`] ? 'is-invalid' : 'select'
                        }
                        placeholder=""
                        value={e?.typeSelected}
                        options={typeOptions}
                        onChange={(e) => $handleItemsChange(i, e, 'typeSelected')}
                        error={
                          StateForm?.errors?.items ||
                          StateForm?.errors[`items.${i}.type`]
                        }
                      />

                      {StateForm?.errors?.items || StateForm?.errors[`items.${i}.type`] ? (
                        <div className="invalid-feedback" style={{ display: 'block' }}>
                          {StateForm?.errors?.items || StateForm?.errors[`items.${i}.type`]}
                        </div>
                      ) : null}
                    </div>
                  </td>
                  <td style={{ whiteSpace: 'initial', width: '200px' }}>
                    <div className="mb-3">
                      <Select.Remote
                        placeholder=""
                        url="/accounting/coa"
                        value={e?.coa_id}
                        initialValue={e?.coa_id}
                        keys={e?.coa_id}
                        name="coa_id"
                        row={(d) => {
                          return {
                            value: d?.id,
                            label: d?.alias_name,
                          };
                        }}
                        onSelected={(e) => $handleItemsChange(i, e, 'coa')}
                      />

                      {StateForm?.errors?.items || StateForm?.errors[`items.${i}.coa_id`] ? (
                        <div className="invalid-feedback" style={{ display: 'block' }}>
                          {StateForm?.errors?.items || StateForm?.errors[`items.${i}.coa_id`]}
                        </div>
                      ) : null}
                    </div>
                  </td>
                  <td style={{ whiteSpace: 'initial', width: '80px' }}>
                    <button
                      type="button"
                      className="btn btn-danger rounded mb-3"
                      style={{ minHeight: 30, minWidth: '100%' }}
                      onClick={() => $removeField(i)}
                      disabled={items?.length === 1}
                    >
                      <Fi.FiX />
                    </button>
                  </td>
                </tr>
              ))}
                <tr>
                  <td colSpan={9}>
                    <button
                      type="button"
                      className="btn btn-primary rounded mb-3"
                      style={{ minHeight: 36, minWidth: '100%' }}
                      onClick={() => $addMoreFields()}
                    >
                      <Fi.FiPlus className="me-2" /> Tambah Item
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
    </div>
  );
};